import React from 'react'
import { Button } from '@paypalcorp/pp-react'
import './login-button.css'

// TODO: remove commented code

// const renderLogInBtn = (loginURL) => {
//   return (
//     <Button className={loginButton} data-js="auth-btn" href={loginURL} data-dxa="login,nav-click,nav-login">Log Into Dashboard</Button>
//     // <div className="dx-auth-logged-out">
//     //   <a className="dx-auth-login dx-btn dx-btn-primary" data-js="auth-btn" href={loginURL} data-dxa="login,nav-click,nav-login">Log into Dashboard</a>
//     // </div>
//   )
// }

interface LoginButtonProps {
  user?: any
  loginURL?: any
}

const LoginButton: React.FC<LoginButtonProps> = ({
  user = {},
  loginURL = {},
}) => {
  const loginContainerClassName = [
    'dx-auth-block container-login profile__container',
    user.loggedIn ? 'dx-authed' : '',
  ]
    .join(' ')
    .trim()

  return (
    <div>
      <div className={loginContainerClassName}>
        <a
          data-js="auth-btn"
          href={loginURL}
          data-dxa="login,nav-click,nav-login"
        >
          <Button className="login-button">Log Into Dashboard</Button>
        </a>
      </div>
    </div>
  )
}

export default LoginButton
